import React from 'react'
import Helmet from 'react-helmet'

import Form from '../Form.js'
import './Contact.css'

const Contact = ({etsy, instagram}) => {
  return (
    <div className='Contact fadeIn'>
      <div className='section'>
        <div className='container skinny'>
          <p>If you have any feedback or want to get in touch, <br />use the form below or find me on:</p>
          <p><a href={instagram}><i className='fa fa-instagram' /></a><a href={etsy}><i className='fa fa-etsy' /></a></p>
        </div>
      </div>
      <div className='section thin'>
        <div className='container'>
          <Form />
        </div>
      </div>
      <Helmet title='Contact' />
    </div>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/Contact/Contact.js